const yup = require('yup')
const { labelify } = require('./helpers')

const shape = labelify({
  uid: yup.string(),
  date: yup.date(),
  attendeeCount: yup.number().default(0),
  event: yup.mixed(),
  calendars: yup.array().of(yup.mixed()).default([]),
  attendanceEntered: yup.boolean().nullable().default(false),
  waitlist: yup
    .array()
    .of(
      yup.object().shape({
        _id: yup.string(),
        profile: yup.mixed(),
        count: yup.number(),
      })
    )
    .default([]),
})

const eventInstanceSchemaPartial = yup.object().shape(shape)
const eventInstanceSchema = eventInstanceSchemaPartial

const eventInstanceResponseSchema = eventInstanceSchema.shape({
  _id: yup.mixed(),
  event: yup
    .object()
    .shape({
      _id: yup.mixed(),
      title: yup.string().default(''),
      label: yup.string().default(''),
      eventType: yup.string().oneOf(['Event', 'Menu']).default('Event'),
      mealType: yup.string().nullable(),
      startAt: yup.date(),
      endAt: yup.date(),
      allDay: yup.boolean(),
      repeatType: yup.string(),
      image: yup
        .object()
        .shape({
          secure_url: yup.string().default(''),
          url: yup.string().default(''),
          created_at: yup.date(),
          type: yup.string().default(''),
          public_id: yup.string(),
          format: yup.string().default('jpg'),
          resource_type: yup.string().default('image'),
          version: yup.number().default(0),
        })
        .nullable(),
      location: yup.string(),
      locationShortCode: yup.string(),
      locationLinkOnMobile: yup.string(),
      featured: yup.boolean().default(false),
      eventLabelRef: yup.string().ensure(),
      mealLocation: yup.mixed(),
      resortEventLocation: yup.mixed(),
      attendanceDisabled: yup.boolean().default(false),
      rsvp: yup
        .object()
        .shape({
          availability: yup.string().ensure().default(''),
          capacity: yup.number().default(0),
          maxPartySize: yup.number().default(0),
          isWaitlistEnabled: yup.boolean().nullable().default(false),
        })
        .nullable(),
    })
    .nullable(),
  attendance: yup
    .object()
    .shape({ _id: yup.mixed(), participated: yup.boolean().nullable(), participationStatus: yup.string().nullable(), notes: yup.string().nullable() })
    .nullable(),
  attendanceEntered: yup.boolean().nullable(),
  startAt: yup.date(),
  endAt: yup.date(),
  eventType: yup.string(),
  mealLocation: yup.mixed(),
  rsvpCount: yup.number(),
  cancelled: yup.boolean().nullable().default(false),
})

module.exports = { eventInstanceSchema, eventInstanceSchemaPartial, eventInstanceResponseSchema }
